import {CommunityLessonPlanCard} from '../../shared/components';
import {Link} from 'react-router';
import {List} from 'immutable';
import React, {PropTypes} from 'react';

export default function CommunityLessonPlans({lessonPlans, gradeText}) {
  const cardStyle = {
    marginRight: '2%',
    borderRadius: 5,
    flexGrow: 1,
    minWidth: '31%',
    maxWidth: '31%',
  };

  const makeLessonPlanCard = lessonPlan => {
    if (!lessonPlan) return null;
    return (
      <Link key={`community-lesson-${lessonPlan.get('id')}`} to={`/community/lesson/${lessonPlan.get('id')}`} style={cardStyle}>
        <CommunityLessonPlanCard
          displayType={lessonPlan.get('displayType')}
          objectType={lessonPlan.get('cardType')}
          objectId={lessonPlan.get('id')}
          featuredImage={lessonPlan.get('featuredImage')}
          title={lessonPlan.get('title')}
          gradeText={gradeText}
          characterName={lessonPlan.get('characterName')} 
          subject={lessonPlan.get('subject')} />
      </Link>
    );
  };

  return (
    <div className="community-lesson-plan-card-list">
      { lessonPlans.map(p => makeLessonPlanCard(p))}
    </div>
  );
}

CommunityLessonPlans.defaultProps = {
  lessonPlans: new List(),
};

CommunityLessonPlans.propTypes = {
  gradeText: PropTypes.string.isRequired,
  lessonPlans: PropTypes.instanceOf(List).isRequired,
};



// WEBPACK FOOTER //
// ./app/features/community/components/CommunityLessonPlans.js